import { ObservationService } from 'client/services';

const action = async ({ request }) => {
    if (request.method === 'DELETE') {
        const { systemIds } = Object.fromEntries(await request.formData());
        if (systemIds) {
            await ObservationService.deleteObservations(systemIds);
            return { deleted: true };
        }
    }
    return {};
};

export default action;
